import * as React from 'react';

import { Race } from '@/lib/apollo/types/gen/graphql';
import { formatRaceInfoText } from '@/lib/race';

import { RaceNumber, Wrapper } from './style';

interface GradeInfoProps {
  race: Race;
}

const GradeInfo: React.FC<GradeInfoProps> = React.memo(({ race }) => {
  return (
    <Wrapper>
      <RaceNumber>{`${race.raceNum}R`}</RaceNumber>
      <span>{formatRaceInfoText(race.raceClassName, race.raceEventName)}</span>
    </Wrapper>
  );
});

export default GradeInfo;
